module.exports = __webpack_public_path__ + "img/terranova_logo_fundo_branco.66bd9837.png";